import { Avatar, Box, Container, Typography } from "@mui/material";
import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "../../store";
import theme from "../../theme";
import { fetchCompanyList, getCompany } from "../../slices/company";
import InfoBoxGroup from "../base/InfoBoxGroup";
import Company from "../../types/company";
import Button from "../base/Button";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "../base/CompanyLogo";

interface Props {
  handleSelect?: (company: Company) => void;
  hideRegister?: boolean;
}

const Companies: FC<Props> = (props) => {
  const { handleSelect, hideRegister } = props;

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { allowedCompanies } = useSelector((store) => store.company);

  useEffect(() => {
    if (allowedCompanies?.length! < 1) {
      dispatch(fetchCompanyList());
    }
  }, [dispatch, allowedCompanies]);

  const handleSelectCompany = async (company: Company) => {
    await dispatch(getCompany(company.id));
    if (handleSelect) {
      handleSelect(company);
    }
  };

  const handleRegisterCompany = () => {
    navigate("/new");
  };

  const companies = allowedCompanies?.map((company) => {
    return (
      <Box
        key={company.id}
        onClick={() => {
          handleSelectCompany(company);
        }}
        display="flex"
        flexDirection="column"
        gap={3}
        justifyContent="space-between"
        alignItems="center"
        sx={{
          cursor: "pointer",
          backgroundColor: theme.palette.background.default,
          paddingY: { xs: 5, md: 7 },
          paddingX: { xs: 2, md: 7 },
          borderRadius: 2,
          fontSize: 20,
          width: "100%",
          minWidth: 0,
          flexShrink: 0,
        }}
      >
        {company?.settings?.reportLogo && (
          <CompanyLogo company={company} size="170px" />
        )}
        <Box
          display="flex"
          flexDirection="row"
          sx={{
            alignItems: "center",
            flexGrow: 1,
            flexShrink: 1,
            minWidth: "0",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            height: "100%",
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            {company.settings?.companyName}
          </Typography>
        </Box>
      </Box>
    );
  });

  return (
    <Container sx={{ marginBottom: 8 }}>
      <InfoBoxGroup content={companies} />
      {!hideRegister && (
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="flex-end"
          marginTop={10}
        >
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Button
              label="Register New Company"
              variant="contained"
              onClick={handleRegisterCompany}
            />
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default Companies;
